import React, { Component } from "react";
import DefaultComponent from "../util/StyledComponents/DefaultComponent";
class Devices extends Component {
  render() {
    return <DefaultComponent>DEVICES</DefaultComponent>;
  }
}

export default Devices;
